import { MerchantState } from './merchant.models';
import { createReducer, Action } from '@ngrx/store';

export const initialState: MerchantState = {
  merchant_field             : undefined,
  additional_info            : undefined
};

const reducer = createReducer(
  initialState,
);

export function merchantReducer(
  state: MerchantState | undefined,
  action: Action
): MerchantState {
  return reducer(state, action);
}
